import React from 'react';

import { useIntl } from 'react-intl-next';

import GrowDiagonalIcon from '@atlaskit/icon/core/grow-diagonal';

import messages from '../../../common/messages';
import { PreviewPanelAction } from '../../../common/ui/preview-panel-action';

import type { PreviewPanelExpandProps } from './types';

export const PreviewPanelExpand = ({
	onClick,
	testId,
	analyticsContext,
}: PreviewPanelExpandProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<PreviewPanelAction
			label={formatMessage(messages.previewPanelExpandActionLabel)}
			icon={GrowDiagonalIcon}
			onClick={onClick}
			testId={testId}
			analyticsContext={analyticsContext}
		/>
	);
};
